import React, { useEffect,useState  } from "react";
import CorreggiBrand from "./CorreggiBrand";
import apiUrl from "../Apiurl";

function DBToolsMenu() {
          

//TODO Prima o poi devo togliere questo file e condensare tutto in CorreggiBrand.js, questo file doveva essere il menu di vari tools ma è diventato il contenitore di un tool solo

const [brandSelezionato, setBrandSelezionato] = useState("");
const [listaBrand, setListaBrand] = useState([]);
    

    useEffect(() => {
        //copiare anche qui la stessa cosa che fa la funz da tradurre o non far visualizzare niente
        fetch(apiUrl + "/prodotti/get/brand")
          .then(resp => resp.json())
          .then(data => setListaBrand(data))
      }, []);



///// PAGINA

    return (
        <div className="areaComposizione fr colonnaTuttaPagina">
            <div className="sfondoBiancoTema br4 shadow-4">
                {/* tab === "correggiBrand" &&  */<CorreggiBrand brand={brandSelezionato} setBrand={setBrandSelezionato} listaBrand={listaBrand}/>}
            </div>
        </div>
    )
}

export default DBToolsMenu;